import React from "react";

export default class CookiePolicy extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            display: true
        };

        this.acceptCookies = this.acceptCookies.bind(this);
        this.openPolicy = this.openPolicy.bind(this);
    }

    acceptCookies() {
        GBEUtils.setCookie("knowsCookies", "true", 90, "None;Secure");
        this.setState({
            display: false
        });
    }

    openPolicy(url) {
        const params = "left=" + (screen.width - 730) + ",top=30,width=1060,height=430,resizable=yes,scrollbars=auto";
        window.open(url, "HelpCenter", params);
    }

    render() {
        const thisComponent = this;
        const gtv = GBEglobal.settings.cookiePolicy;
        const privacy = <span className="privacyPolicyLink" onClick={thisComponent.openPolicy.bind(this, gtv.privacyPolicyLink)}>Privacy Policy</span>;
        const cookie = <span className="cookiePolicyLink" onClick={thisComponent.openPolicy.bind(this, gtv.cookiePolicyLink)}>Cookie Policy</span>;
        const content = String.format(gtv.text, "|", "|").split("|");
        const result = [content[0].trim(), privacy, content[1].trim(), cookie, content[2].trim()];
        return (
            <>
                {this.state.display &&
                    <div className="cookiePolicy">
                        <div className="set-max-width">
                            <div className="row">
                                <div className="cookiePolicyTitle col-12">Privacy and Cookie Policy</div>
                            </div>
                            <div className="row">
                                <div className="cookiePolicyContent col">
                                    {result.map((part) => {
                                        return part;
                                    })}
                                </div>
                                <div className="col text-right">
                                    <button className="continue btn" onClick={thisComponent.acceptCookies}>
                                        Accept
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </>
        );
    }
}

export { CookiePolicy };